import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemUiAnnouncementBannerRoute: InvariantJiraRoute = {
	name: 'global-settings-system-ui-announcement-banner',
	path: '/jira/settings/system/ui/announcement-banner',
};
